import { render, staticRenderFns } from "./PixelReport.vue?vue&type=template&id=4803b6ec"
import script from "./PixelReport.vue?vue&type=script&lang=js"
export * from "./PixelReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports